import styled from "styled-components"

export const StyledGrid = styled.div`
  display: grid;
  grid-column-gap: ${(props) => props.guttersWide}px;
  grid-row-gap: ${(props) => props.guttersWide}px;
  grid-template-columns: repeat(${(props) => props.columnsWide}, 1fr);
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    grid-template-columns: repeat(${(props) => props.columnsDesktop}, 1fr);
    grid-column-gap: ${(props) => props.guttersDesktop}px;
    grid-row-gap: ${(props) => props.guttersDesktop}px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    grid-template-columns: repeat(${(props) => props.columnsTablet}, 1fr);
    grid-column-gap: ${(props) => props.guttersTablet}px;
    grid-row-gap: ${(props) => props.guttersTablet}px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    grid-template-columns: repeat(${(props) => props.columnsMobile}, 1fr);
    grid-column-gap: ${(props) => props.guttersMobile}px;
    grid-row-gap: ${(props) => props.guttersMobile}px;
  }

  & > div {
    min-width: 0;
  }
`
